var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreHoriz(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.815-425.782q-22.077 0-38.055-15.927-15.978-15.927-15.978-38.293 0-22.824 15.968-38.52 15.968-15.696 38.391-15.696 21.893 0 38.267 15.698 16.374 15.697 16.374 38.239 0 22.542-16.445 38.52-16.445 15.979-38.522 15.979Zm285.466 0q-22.542 0-38.52-15.927-15.979-15.927-15.979-38.293 0-22.824 15.927-38.52 15.927-15.696 38.293-15.696 22.824 0 38.52 15.698 15.696 15.697 15.696 38.239 0 22.542-15.698 38.52-15.697 15.979-38.239 15.979Zm284.598 0q-22.665 0-38.663-15.927-15.998-15.927-15.998-38.293 0-22.824 16.14-38.52 16.14-15.696 38.804-15.696 22.665 0 38.643 15.698 15.979 15.697 15.979 38.239 0 22.542-16.12 38.52-16.12 15.979-38.785 15.979Z"
  })));
}
export default SvgMoreHoriz;